import { Outlet } from 'react-router-dom';

function Tasks(){
    return(
        <Outlet/>
    );
}

export default Tasks;
  